import axios from "axios";
import VueCookie from "vue-cookie";

let isLog = false;
let serverApiUrl = "";
if (process.env.NODE_ENV === "development") {
  console.log("开发环境");
  serverApiUrl = "/suqianServer";
} else {
  console.log("生产环境");
  serverApiUrl = "https://ebdc.ssipac.suqian.gov.cn:8001/suqianServer";
}

export default {
  isMobile: () => {
    let type = "pc";
    var isMobile = false;
    var isiPhoneiPad = false;
    let show = navigator.userAgent;
    console.log("获取的环境", show);
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      isMobile = true;
      type = "mobile";
    }
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      isiPhoneiPad = true;
      type = "ipad";
    }
    return { type, isMobile, isiPhoneiPad };
  },
  /**
   * 获取请求路径
   */
  getServerUrl: () => {
    return serverApiUrl;
  },
  setImgUrl: (url, type = "show") => {
    //console.log("设置地址", type);
    let imgSrc = "";

    if (type == "pic") {
      imgSrc =
        serverApiUrl +
        "/t19itemFileC/pic?pathurl=" +
        url +
        "&token=" +
        VueCookie.get("token");
    } else if (type == "show") {
      imgSrc =
        serverApiUrl +
        "/t19itemFileC/show?pathurl=" +
        url +
        "&token=" +
        VueCookie.get("token");
    } else if (type == "picJm") {
      // 转换成加密显示的路径
      imgSrc =
        serverApiUrl +
        "/t19itemFileC/picJm?pathurl=" +
        url +
        "&token=" +
        VueCookie.get("token");
    } else if (type == "downJm") {
      // 转换成加密显示的路径
      imgSrc =
        serverApiUrl +
        "/t19itemFileC/downJm?pathurl=" +
        url +
        "&token=" +
        VueCookie.get("token");
    } else if (type == "showJm") {
      // 转换成加密显示的路径
      imgSrc =
        serverApiUrl +
        "/t19itemFileC/showJm?pathurl=" +
        url +
        "&token=" +
        VueCookie.get("token");
    }
    return imgSrc;
  },
  http: (url, param, type = "post", conType) => {
    if (!param) {
      type = "get";
    }
    let options = {
      method: type,
      // data: param,
      url
    };
    if (type == "get") {
      let relParam = {};
      if (param.params) {
        relParam = param.params;
      } else {
        relParam = param;
      }
      options["params"] = relParam;
    } else {
      if (conType) {
        // console.log("传了头", conType);
        options["headers"] = { "Content-type": conType };
      } else {
        options["headers"] = {
          "Content-type": "application/json;charset=UTF-8"
        };
      }
      options["data"] = param;
    }
    return axios(options);
  },
  cusHttp: (url, param, type = "post", config = {}) => {
    if (!param) {
      type = "get";
    }
    let options = {
      method: type,
      // data: param,
      url
    };

    if (type == "get") {
      let relParam = {};
      if (param.params) {
        relParam = param.params;
      } else {
        relParam = param;
      }
      options["params"] = relParam;
    } else {
      if (config.conType) {
        options["headers"] = { "Content-type": config.conType };
      } else {
        options["headers"] = {
          "Content-type": "application/json;charset=UTF-8"
        };
      }
      options["data"] = param;
    }
    options = { ...options, ...config };
    console.log("------------", options);
    return axios(options);
  },

  //获取服务器地址
  getBaseUrl: () => {
    let url = serverApiUrl;
    return url;
  },
  //获取文件类型
  getFileType: file => {
    let info = file.raw;
    let oldType = JSON.parse(JSON.stringify(info.type));
    console.log("文件类型", file);
    switch (oldType) {
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        file.fileType = "docx";
        file.showType = "docx";
        break;

      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        file.fileType = "xlsx";
        file.showType = "xlsx";

        break;
      case "application/vnd.ms-excel":
        file.fileType = "xls";
        file.showType = "xls";
        break;
      case "application/msword":
        file.fileType = "doc";
        file.showType = "doc";

        break;
      case "application/pdf":
        file.fileType = "pdf";
        file.showType = "pdf";

        break;
      case "application/octet-stream":
        file.fileType = "odf";
        file.showType = "odf";
        break;
      default:
        break;
    }
    if (oldType.search("image") != -1) {
      let type = oldType.split("/");
      file.fileType = type[1];
      file.showType = "img";
    }
    return file;
  },
  getFileTypeByType: oldType => {
    let newType = "";
    console.log("文件类型", oldType);
    switch (oldType) {
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        newType = "docx";
        break;
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        newType = "xlsx";
        break;
      case "application/vnd.ms-excel":
        newType = "xls";
        break;
      case "application/msword":
        newType = "doc";
        break;
      case "application/pdf":
        newType = "pdf";
        break;
      case "text/plain":
        newType = "text";
        break;
      case "application/octet-stream":
        newType = "odf";
        break;
      default:
        break;
    }
    if (oldType.search("image") != -1) {
      let type = oldType.split("/");
      newType = type[1];
    }
    return newType;
  },
  isArrayFn: o => {
    return Object.prototype.toString.call(o) === "[object Array]";
  },
  log: (str, field) => {
    if (isLog) {
      let localhost = window.location.pathname;

      //console.log(`页面地址${localhost}：`, str, field);
    }
  },
  componentLog: myState => {
    let state = myState;

    let func = (str, field) => {
      if (state.isLog) {
      }
    };
    return func;
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/common.js